<script setup>
import MarketingLayout from '@/Layouts/MarketingLayout.vue';

defineOptions({
    name: 'MarketingNotFoundPage',
});

const goBack = () => {
    window.history.back();
};
</script>

<template>
  <MarketingLayout title="Pagina niet gevonden">
    <div class="mx-auto max-w-3xl px-4 py-24 text-center sm:px-6 lg:px-8">
      <p class="text-7xl font-bold text-gray-300">
        404
      </p>
      <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900">
        Pagina niet gevonden
      </h1>
      <p class="mt-4 text-base text-gray-600">
        Deze pagina bestaat niet (meer). Misschien is de link verouderd of werd de pagina verplaatst.
      </p>
      <div class="mt-8 flex justify-center gap-3">
        <button
          type="button"
          class="inline-flex items-center justify-center rounded-md bg-white px-4 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
          @click="goBack"
        >
          Vorige pagina
        </button>
        <a
          :href="route('marketing.dashboard')"
          class="inline-flex items-center justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500"
        >
          Naar startpagina
        </a>
      </div>
    </div>
  </MarketingLayout>
</template>
